import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { SideBarComponent } from '../side-bar/side-bar.component';
import { LitigationComplaintsService } from '../litigation-complaints/litigation-complaints.service';
import { ToastMessageService } from 'src/app/toastr.service';
import { UserRegistrationService } from '../user-registration/user-registration.service';
@Component({
  selector: 'app-company-master',
  templateUrl: './company-master.component.html',
  styleUrls: ['./company-master.component.scss']
})
export class CompanyMasterComponent implements OnInit {
  companyForm!: FormGroup;
  loading = true;
  userData: any;
  constructor(private fb: FormBuilder, private LitigationComplaintsService: LitigationComplaintsService, private toastService: ToastMessageService, private userRegistrationService: UserRegistrationService) {}

  ngOnInit(): void {
    this.companyForm = this.fb.group({
      company_name: ['', Validators.required],
      start_date: ['', Validators.required],
      expiry_date: ['', Validators.required],
      status: ['Active', Validators.required],
    }, { validators: this.expiryDateAfterStartDateValidator });
    this.getUserRegisterData();
  }

  getUserRegisterData() {
    this.userRegistrationService.companyDataUpdate().subscribe((response) => {
      this.userData = response["data"];
      this.loading = false;
    });
  }

  editRow(rowData: any) {
    rowData.isEditing = true;
    rowData.originalEndDate = rowData.expiry_date; // Save the original value for cancel functionality
  }

  // Custom validator function
  expiryDateAfterStartDateValidator(group: AbstractControl): ValidationErrors | null {
    const startDate = group.get('start_date')?.value;
    const expiryDate = group.get('expiry_date')?.value;

    if (!startDate || !expiryDate) {
      return null; // Don't validate if one is empty, let required handle it
    }

    // Compare dates
    const start = new Date(startDate);
    const expiry = new Date(expiryDate);

    return expiry >= start ? null : { expiryBeforeStart: true };
  }

  isFieldInvalid(field: string): boolean {
    const control = this.companyForm.get(field);
    return !!(control && control.invalid && (control.dirty || control.touched));
  }
  validateDateFormat(dateString: string): boolean {
    const datePattern = /^([0-2][0-9]|(3)[0-1])-(0[1-9]|1[0-2])-\d{4}$/;
    return datePattern.test(dateString);
  }
  convertToDDMMYYYY(dateString: string) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }
  onSubmit() {
    if (this.companyForm.valid) {
     var start_date = this.convertToDDMMYYYY(this.companyForm.value.start_date);
      var expiry_date = this.convertToDDMMYYYY(this.companyForm.value.expiry_date);

      // console.log(start_date);
      // console.log(expiry_date);
      // if (!this.validateDateFormat(this.companyForm.value.start_date)) {
      //   this.companyForm.get('start_date')?.setErrors({ invalidDate: true });
      //   return;
      // }
      // if (!this.validateDateFormat(this.companyForm.value.expiry_date)) {
      //   this.companyForm.get('expiry_date')?.setErrors({ invalidDate: true });
      //   return;
      // }
      console.log(this.companyForm.value);

      // submit logic
      this.loading = true;

      this.LitigationComplaintsService.getCompanyMasterData({
      "company_name": this.companyForm.value.company_name,
      "start_date":start_date,
      "expiry_date": expiry_date,
      "status": this.companyForm.value.status,
      "user_email": localStorage.getItem("email") || ""

      }).subscribe({
        next: (res: any) => {
          this.toastService.success("Company Added Successfully");
            this.loading = false;
            this.companyForm.reset();
            this.getUserRegisterData();
        },
        error: () => {
          this.toastService.error("Something went wrong");

          this.loading = false;
        }
      });
    } else {
      this.companyForm.markAllAsTouched();
    }
  }
  changeUserStatus(rowData: any, status: any) {
    console.log(rowData, status);
    const data={
      "company_name": rowData?.company_name,
      "status":status ? "Active" :"Deactive"
  }
    this.userRegistrationService.changeUserStatus(data).subscribe((response) => {
      this.toastService.success("Status Changed Successfully");
      this.getUserRegisterData();
    });
  }
  saveRow(rowData: any) {
    console.log(rowData);
    rowData.isEditing = false;

    // Ensure the end_date is in dd/mm/yyyy format before saving
    if (rowData.expiry_date) {
      let formattedDate = "";
  
      // Check if it's the "DD-MM-YYYY" format
      if (/^\d{2}-\d{2}-\d{4}$/.test(rowData.expiry_date)) {
          formattedDate = rowData.expiry_date
      } else {
          // Assume it is a Date string (Sat May 31 2025 ...)
          const dateObj:any = new Date(rowData.expiry_date);
          if (!isNaN(dateObj)) {
            const day = String(dateObj.getDate()).padStart(2, '0');
            const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
            const year = dateObj.getFullYear();
            
           rowData.expiry_date = `${day}-${month}-${year}`;
              console.log("formattedDate=139",formattedDate);
          } else {
              console.error("Invalid expiry_date format:", rowData.expiry_date);
          }
      }
  
      // rowData.expiry_date = formattedDate;
    }
    // console.log('Updated row:', rowData);
    const UserData = {
      company_name: rowData.company_name,
      expiry_date: rowData.expiry_date,
    };
    this.userRegistrationService.updateCompanyExpiryDate(UserData).subscribe(
      (response) => {
        console.log('Company expiry date updated successfully:', response);
        this.toastService.success('Company expiry date updated successfully.');
        // Refresh user data after update
        this.getUserRegisterData();
      },
      (error) => {
        console.error('Error updating company expiry date:', error);
        this.toastService.error('An error occurred while updating company expiry date. Please try again later.');
      }
    );
  }
  onDateChange(event: any, rowData: any, rowIndex: number) {
    console.log('rowdataaa', rowData);

    // Parse start date
    const [startDay, startMonth, startYear] = rowData['start_date'].split('-').map(Number);
    const startDate = new Date(startYear, startMonth - 1, startDay);

    // Parse end date from event
    const endDate = new Date(event);
    const endDateString = endDate.toLocaleDateString('en-GB');

    console.log("start", startDate);
    console.log("end", endDateString);

    // Compare dates including month and date
    if (startDate > endDate) {
      rowData.dateError = 'End date cannot be earlier than start date.';
      rowData.expiry_date = null; // Reset the expiry date if invalid
    } else {
      // Additional check for same month/year
      if (startDate.getFullYear() === endDate.getFullYear() && 
          startDate.getMonth() === endDate.getMonth() &&
          startDate.getDate() > endDate.getDate()) {
        rowData.dateError = 'End date cannot be earlier than start date within the same month.';
        rowData.expiry_date = null;
      } else {
        rowData.dateError = ''; // Clear the error
        rowData.expiry_date = event; // Update the date in the row data
      }
    }

    console.log(`Date changed for row ${rowIndex}:`, rowData);
  }
  cancelEdit(rowData: any) {
    rowData.isEditing = false;
    rowData.expiry_date = rowData.originalEndDate; // Revert to the original value
    delete rowData.originalEndDate;
  }
}
